import { PageLayoutDefaultErrorPageProps } from '@sis/react-library';
import sislogo from '../images/SIS_Logo.svg';
import { commonRoutes } from '../shared/commonRoutes';

export const ErrorPageProps = (): PageLayoutDefaultErrorPageProps => {
    return {
        logoSrc: sislogo,
        projectTitle: "Test components",
        homeUrl: commonRoutes.home
    }
}
